import { useState } from 'react';

export default function AvailableKittens() {
  const [selectedKitten, setSelectedKitten] = useState<number | null>(null);

  const kittens = [
    {
      name: 'Luna',
      age: '10 weeks',
      color: 'Seal Point',
      gender: 'Female',
      temperament: 'Calm and cuddly, loves gentle play',
      health: 'Vet-checked, vaccinated, dewormed',
      image: 'https://static.readdy.ai/image/d150b0faf33c242200df45b9c741fb38/5212da447ffdaeeed829ca755eceed59.jpeg'
    },
    {
      name: 'Oliver',
      age: '12 weeks',
      color: 'Blue Point Mitted',
      gender: 'Male',
      temperament: 'Playful yet gentle, very affectionate',
      health: 'Vet-checked, vaccinated, dewormed',
      image: 'https://static.readdy.ai/image/d150b0faf33c242200df45b9c741fb38/133840f952b0b74efeb2037f92dbc6b0.jpeg'
    },
    {
      name: 'Bella',
      age: '9 weeks',
      color: 'Bicolor',
      gender: 'Female',
      temperament: 'Sweet and relaxed, perfect lap cat',
      health: 'Vet-checked, vaccinated, dewormed',
      image: 'https://static.readdy.ai/image/d150b0faf33c242200df45b9c741fb38/e06b369a5c10fd5d55fd4d10f2cd618f.jpeg'
    },
    {
      name: 'Max',
      age: '11 weeks',
      color: 'Seal Point Mitted',
      gender: 'Male',
      temperament: 'Gentle giant, loves cuddles',
      health: 'Vet-checked, vaccinated, dewormed',
      image: 'https://static.readdy.ai/image/d150b0faf33c242200df45b9c741fb38/21e5813539178965cf7dad2857f22875.jpeg'
    },
    {
      name: 'Daisy',
      age: '8 weeks',
      color: 'Blue Point',
      gender: 'Female',
      temperament: 'Calm and curious, very social',
      health: 'Vet-checked, vaccinated, dewormed',
      image: 'https://static.readdy.ai/image/d150b0faf33c242200df45b9c741fb38/d0a77856b1ae8b1321824156137fe07d.jpeg'
    },
    {
      name: 'Charlie',
      age: '14 weeks',
      color: 'Seal Bicolor',
      gender: 'Male',
      temperament: 'Playful and loving, great with kids',
      health: 'Vet-checked, vaccinated, dewormed',
      image: 'https://static.readdy.ai/image/d150b0faf33c242200df45b9c741fb38/e6eaf7e171cf47dd35cf656fb43a016d.jpeg'
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="available-kittens" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Available Kittens</h2>
          <p className="text-xl text-gray-600">Meet our beautiful Ragdoll kittens ready for their forever homes</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {kittens.map((kitten, index) => (
            <div 
              key={index}
              className="bg-gradient-to-b from-blue-50 to-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2"
            >
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={kitten.image}
                  alt={`${kitten.name} - ${kitten.color} Ragdoll kitten`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">{kitten.name}</h3>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center text-gray-700">
                    <i className="ri-time-line text-blue-400 mr-3 text-xl w-6 h-6 flex items-center justify-center"></i>
                    <span><strong>Age:</strong> {kitten.age}</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <i className="ri-palette-line text-purple-300 mr-3 text-xl w-6 h-6 flex items-center justify-center"></i>
                    <span><strong>Color:</strong> {kitten.color}</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <i className={`${kitten.gender === 'Male' ? 'ri-men-line' : 'ri-women-line'} text-blue-400 mr-3 text-xl w-6 h-6 flex items-center justify-center`}></i>
                    <span><strong>Gender:</strong> {kitten.gender}</span>
                  </div>
                  <div className="flex items-start text-gray-700">
                    <i className="ri-heart-3-line text-purple-300 mr-3 text-xl w-6 h-6 flex items-center justify-center mt-1"></i>
                    <span><strong>Temperament:</strong> {kitten.temperament}</span>
                  </div>
                  <div className="flex items-start text-gray-700">
                    <i className="ri-health-book-line text-blue-400 mr-3 text-xl w-6 h-6 flex items-center justify-center mt-1"></i>
                    <span><strong>Health:</strong> {kitten.health}</span>
                  </div>
                </div>
                <button 
                  onClick={scrollToContact}
                  className="whitespace-nowrap w-full py-4 bg-gradient-to-r from-blue-400 to-purple-300 text-white rounded-full font-semibold text-lg hover:from-blue-500 hover:to-purple-400 transition-all shadow-lg hover:shadow-xl cursor-pointer"
                >
                  Adopt Me
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
